var _defs, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSignature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logo__signature",
    width: 144,
    height: 155,
    viewBox: "0 0 144 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#333}.cls-2{fill:#7851e7}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1792",
    transform: "translate(-30 -112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1919",
    d: "M64.776 232.875l-14.353 33.25H44.4L30 232.875h6.636l10.964 25.65 11.058-25.65z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1920",
    d: "M167.883 266.125l-11.058-25.65-10.965 25.65h-6.636l14.4-33.25h6.024L174 266.125z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1921",
    d: "M64.693 249.5c0-10.062 7.706-17.5 18.156-17.5S101 239.388 101 249.5 93.3 267 82.849 267s-18.156-7.437-18.156-17.5zm30 0a11.848 11.848 0 1 0-11.846 11.958A11.542 11.542 0 0 0 94.695 249.5z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1922",
    d: "M105.852 232h15.157c11.245 0 18.922 7 18.922 17.5s-7.677 17.5-18.922 17.5h-15.157zm14.861 29.5c7.725 0 12.729-4.749 12.729-12s-5-12-12.729-12h-8.422v24z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1793",
    transform: "translate(-30 -112)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1923",
    d: "M174 212h-21.037l-44.491-100h21.037z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1924",
    d: "M129.5 112h-21.033L63.976 212h21.038z",
    style: {
      isolation: "isolate"
    },
    fill: "#ff9931",
    opacity: 0.8
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1925",
    d: "M30 135.637L63.975 212h21.037l-33.975-76.363z",
    className: "cls-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSignature);
export default __webpack_public_path__ + "static/media/logo-signature.7098f933.svg";
export { ForwardRef as ReactComponent };